
/*eslint-disable */

import Multiselect from 'vue-multiselect';
import {bus} from '@/main';
import toast from '@/services/toast';
export default {
  name: 'candidate-contest-histories-popup',
  components: {
    Multiselect
  },
  props: ['candidateID', 'qBankID'],
  data () {
    return {
      qBankData:null,
      qbankRslts:[],
      selectedQBank:'',
      isSubmitted:false,
      linkageQBankInfo:null,
      linkageQBankInfoRslts:[],
    }
  },
  computed: {

  },
  mounted () {
    this.$store.dispatch('getContestHistoriesDataAction', {data:{ck:this.candidateID, qk:this.qBankID}}).then((res) => {
        this.qBankData = res.data.data
        // this.qbankRslts = this.qBankData.data
    })
  },
  methods: {
    closeCandidateContHisPopupMethod(){
      bus.$emit('contestHistoriesPopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
  }
}